import api from "../apis/WorkshopApi";
import * as constant from "../constants/Constant";

export const CreateWorkshop = (data, onSuccess, onError) => (dispatch) => {
  dispatch({
    type: constant.CREATE_WORKSHOP,
    payload: { loading: true }
  });
  
  api
    .WorkshopApis()
    .createWorkshop(data)
    .then((res) => {
      dispatch({
        type: constant.CREATE_WORKSHOP,
        payload: { loading: false }
      });
      if (onSuccess) {
        onSuccess(res.data);
      }
    })
    .catch((err) => {
      dispatch({
        type: constant.CREATE_WORKSHOP,
        payload: { loading: false, error: err.response?.data?.message || "Failed to create workshop" }
      });
      console.log(err);
      if (onError) {
        onError(err.response?.data?.message || "Failed to create workshop");
      }
    });
};

export const GetAllWorkshops = (data, onSuccess, onError) => (dispatch) => {
  api
    .WorkshopApis()
    .getAllWorkshops(data)
    .then((res) => {
      dispatch({
        type: constant.GET_ALL_WORKSHOPS,
        payload: res.data,
      });
      if (onSuccess) {
        onSuccess(res.data);
      }
    })
    .catch((err) => {
      console.log(err);
      if (onError) {
        onError(err.response?.data?.message || "Failed to fetch workshops");
      }
    });
};

export const UpdateWorkshop = (data, onSuccess, onError) => (dispatch) => {
  dispatch({
    type: constant.UPDATE_WORKSHOP,
    payload: { loading: true }
  });
  
  api
    .WorkshopApis()
    .updateWorkshop(data)
    .then((res) => {
      dispatch({
        type: constant.UPDATE_WORKSHOP,
        payload: { loading: false }
      });
      if (onSuccess) {
        onSuccess(res.data);
      }
    })
    .catch((err) => {
      dispatch({
        type: constant.UPDATE_WORKSHOP,
        payload: { loading: false, error: err.response?.data?.message || "Failed to update workshop" }
      });
      console.log(err);
      if (onError) {
        onError(err.response?.data?.message || "Failed to update workshop");
      }
    });
};

export const GetWorkshopById = (workshopId, onSuccess, onError) => (dispatch) => {
  api
    .WorkshopApis()
    .getWorkshopById(workshopId)
    .then((res) => {
      dispatch({
        type: constant.GET_WORKSHOP_BY_ID,
        payload: res.data,
      });
      if (onSuccess) {
        onSuccess(res.data);
      }
    })
    .catch((err) => {
      console.log(err);
      if (onError) {
        onError(err.response?.data?.message || "Failed to fetch workshop details");
      }
    });
};

export const GetCommunityLinks = (data, onSuccess, onError) => (dispatch) => {
  api
    .WorkshopApis()
    .getCommunityLinks(data)
    .then((res) => {
      dispatch({
        type: constant.GET_COMMUNITY_LINKS,
        payload: res.data,
      });
      if (onSuccess) {
        onSuccess(res.data);
      }
    })
    .catch((err) => {
      console.log(err);
      if (onError) {
        onError(err.response?.data?.message || "Failed to fetch community links");
      }
    });
};

export const CreateOrUpdateCommunityLink = (data, onSuccess, onError) => (dispatch) => {
  dispatch({
    type: constant.CREATE_OR_UPDATE_COMMUNITY_LINK,
    payload: { loading: true },
  });

  api
    .WorkshopApis()
    .createOrUpdateCommunityLink(data)
    .then((res) => {
      dispatch({
        type: constant.CREATE_OR_UPDATE_COMMUNITY_LINK,
        payload: { loading: false },
      });
      if (onSuccess) {
        onSuccess(res.data);
      }
    })
    .catch((err) => {
      dispatch({
        type: constant.CREATE_OR_UPDATE_COMMUNITY_LINK,
        payload: { loading: false, error: err.response?.data?.message || "Failed to save community link" },
      });
      console.log(err);
      if (onError) {
        onError(err.response?.data?.message || "Failed to save community link");
      }
    });
}; 